import {FC} from 'react'
import {KTCard} from '../../../../../../../../../_metronic/helpers'
import Swal from 'sweetalert2'
import {forceResetPassword} from '../../../../../services'
import {useCentral} from '../../../../../../../hooks/useCentral'
import {ShowSnackBar} from '../../../../../../../util/functions'
export const ResetPassword: FC = () => {
  const {currentTabItem} = useCentral()
  const {idToEdit} = currentTabItem

  const handleResetPassword = () => {
    Swal.fire({
      title: 'Resetear contraseña',
      text: '¿Estas seguro de que deseas resetear la contraseña del usuario?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, resetear contraseña',
      confirmButtonColor: 'var(--kt-primary)',
      cancelButtonText: 'Descartar',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        return forceResetPassword({userId: idToEdit}).then((response) => response.data)
      },
    }).then((result) => {
      const {value, isDismissed} = result
      if (isDismissed) {
        ShowSnackBar('Se canceló el reseteo de la contraseña')
      } else {
        if (value.error) {
          ShowSnackBar(value.message, 'error')
        } else {
          ShowSnackBar('Se reseteó la contraseña correctamente')
        }
      }
    })
  }

  return (
    <div className='p-5'>
      <KTCard>
        <div className='d-flex p-2 me-5'>
          <button type='button' className='btn btn-success me-3' onClick={handleResetPassword}>
            Resetear Contraseña
          </button>
        </div>
      </KTCard>
    </div>
  )
}
